export const CHAT_DOCK_OPEN_EVENT = "adc:chat-dock-open";
export const CHAT_CONVERSATION_OPEN_EVENT = "adc:chat-conversation-open";
export const CHAT_GROUP_OPEN_EVENT = "adc:chat-group-open";
export const CHAT_CONVERSATION_READ_EVENT = "adc:chat-conversation-read";
export const CHAT_GROUP_READ_EVENT = "adc:chat-group-read";

export interface ChatConversationOpenDetail {
  partnerUserId: string;
  partnerName?: string;
}

export interface ChatGroupOpenDetail {
  groupId: string;
  groupName?: string;
  avatarUrl?: string | null;
}

export interface ChatConversationReadDetail {
  partnerUserId: string;
}

export interface ChatGroupReadDetail {
  groupId: string;
}

export const openChatDock = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CHAT_DOCK_OPEN_EVENT));
};

export const openChatConversation = (detail: ChatConversationOpenDetail) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ChatConversationOpenDetail>(CHAT_CONVERSATION_OPEN_EVENT, { detail }));
};

export const openChatGroup = (detail: ChatGroupOpenDetail) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ChatGroupOpenDetail>(CHAT_GROUP_OPEN_EVENT, { detail }));
};

export const notifyChatConversationRead = (detail: ChatConversationReadDetail) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ChatConversationReadDetail>(CHAT_CONVERSATION_READ_EVENT, { detail }));
};

export const notifyChatGroupRead = (detail: ChatGroupReadDetail) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ChatGroupReadDetail>(CHAT_GROUP_READ_EVENT, { detail }));
};
